import { render, staticRenderFns } from "./AdminTranslate.vue?vue&type=template&id=86ec7804&scoped=true"
import script from "./AdminTranslate.vue?vue&type=script&lang=js"
export * from "./AdminTranslate.vue?vue&type=script&lang=js"
import style0 from "./AdminTranslate.vue?vue&type=style&index=0&id=86ec7804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ec7804",
  null
  
)

export default component.exports